"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThrottle = void 0;
var react_1 = require("react");
var throttle_1 = __importDefault(require("lodash/throttle"));
/**
 * Throttle hook for delaying a callback invocation until there is an adequate pause.
 * Useful for invoking callbacks when a user is "done" typing, or making selections
 * @see https://lodash.com/docs/4.17.15#throttle
 */
var useThrottle = function (callback, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.delayMs, delayMs = _c === void 0 ? 1000 : _c, _d = _b.options, options = _d === void 0 ? {} : _d;
    var _e = (0, react_1.useState)(), throttledCallback = _e[0], setThrottledCallback = _e[1];
    /**
     * Register and replace existing throttle, should be replaced during a user action
     */
    var handleCallback = (0, react_1.useCallback)(
    // @ts-ignore
    function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        setThrottledCallback(function (prev) {
            if (prev)
                prev.cancel();
            return (0, throttle_1.default)(function () { return callback.apply(void 0, args); }, delayMs, options);
        });
    }, [callback, delayMs, options]);
    (0, react_1.useEffect)(function () {
        if (throttledCallback)
            throttledCallback();
        // cleanup any timers when unmounting
        return function () {
            if (throttledCallback)
                throttledCallback.cancel();
        };
    }, [throttledCallback]);
    return {
        throttle: handleCallback,
    };
};
exports.useThrottle = useThrottle;
